import {
  BookOpen,
  Building2,
  ClipboardCheck,
  Clock3,
  Contact,
  IdCard,
  KeyRound,
  Landmark,
  LayoutDashboard,
  Lightbulb,
  ListTree,
  Megaphone,
  Mic,
  Network,
  Newspaper,
  NotebookPen,
  Printer,
  Settings,
  ShieldCheck,
  UserPlus,
  Users,
  type LucideIcon,
} from 'lucide-react';

/**
 * The icons a menu entry may name.
 *
 * An explicit list on purpose: resolving names against `lucide-react` as a
 * whole would pull every icon into the initial bundle and blow the 350 kB
 * budget. Adding an icon is one line here; until then an unknown name renders
 * the neutral fallback instead of breaking the menu.
 */
export const MENU_ICONS: Readonly<Record<string, LucideIcon>> = {
  'book-open': BookOpen,
  'building-2': Building2,
  'clipboard-check': ClipboardCheck,
  'clock-3': Clock3,
  contact: Contact,
  'id-card': IdCard,
  'key-round': KeyRound,
  landmark: Landmark,
  'layout-dashboard': LayoutDashboard,
  lightbulb: Lightbulb,
  'list-tree': ListTree,
  megaphone: Megaphone,
  mic: Mic,
  network: Network,
  newspaper: Newspaper,
  'notebook-pen': NotebookPen,
  printer: Printer,
  settings: Settings,
  'shield-check': ShieldCheck,
  'user-plus': UserPlus,
  users: Users,
};

/** Names in a stable order, for the icon picker. */
export const MENU_ICON_NAMES = Object.keys(MENU_ICONS).sort();
